export default __webpack_public_path__ + "static/thumb-landscape-8b0fb3a783c44e39810998e39968c921.jpg";